import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';
import { httpErrorMessage } from '../../../core/utils/http-error-message';
import { CurrentUserService } from '../../../core/auth/current-user.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss',
})
export class ChangePassword {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly currentUser = inject(CurrentUserService);
  form = { newPassword: '', confirmPassword: '' };
  isSaving = false;
  errorMessage = '';

  get isInitialSetup(): boolean {
    return Boolean(this.currentUser.user()?.mustChangePassword);
  }

  save(): void {
    this.errorMessage = '';
    if (this.form.newPassword.length < 8) { this.errorMessage = 'New password must be at least 8 characters.'; return; }
    if (this.form.newPassword !== this.form.confirmPassword) { this.errorMessage = 'Passwords do not match.'; return; }
    this.isSaving = true;
    this.auth.changePassword(this.form).pipe(finalize(() => { this.isSaving = false; this.cdr.detectChanges(); })).subscribe({
      next: () => this.auth.refreshSession().subscribe({
        next: (user) => void this.router.navigate([
          this.route.snapshot.queryParamMap.get('portal') === 'franchise'
            ? '/franchise/dashboard'
            : user.tenantId ? this.currentUser.businessLandingRoute() : '/admin/dashboard',
        ], { queryParams: { passwordChanged: 1 } }),
        error: () => { this.auth.logout(); void this.router.navigate(['/login']); },
      }),
      error: (error: unknown) => { this.errorMessage = httpErrorMessage(error, 'Unable to update the password.'); this.cdr.detectChanges(); },
    });
  }
}
